import { connect } from 'react-redux';
import { mapDispatchToProps } from './redux';
import { SaveButton } from './component';


export default connect(null, mapDispatchToProps)(SaveButton);
